import moment from "moment";

export const buildDate = (date = "2021/04/01", format = "YYYY/MM/DD日") => {
  return moment(date).format(format);
};
